import { Record } from 'immutable'

export interface IGeoJsonPoint {
  readonly latitude: number
  readonly longitude: number
}

const GeoJsonPointRecord = Record({
  latitude: 0,
  longitude: 0,
})

export class GeoJsonPoint extends GeoJsonPointRecord implements IGeoJsonPoint {
  public static fromJS(initialState?: IGeoJsonPoint) {
    return new GeoJsonPoint(initialState)
  }

  public readonly latitude: number
  public readonly longitude: number

  constructor(props?: Partial<GeoJsonPoint>) {
    props ? super(props) : super()
  }
}
